import { Environment } from "../app/_shared/models/environment.model";

export const environment: Environment = {
    production: false,
    apiEndpoint: 'https://qa.globalwebtrack.com/v2/api',
    eagleOneUrl: 'https://qa.globalwebtrack.com/app/#/',
    supportUrl: 'https://support.globaltrack.com/support/tickets/new',
    socialLoginConfig: {
        google: {
            clientId: '770135230634-uf4461p01vf08vt1h58eip3r8h24109o.apps.googleusercontent.com'
        },
        microsoft: {
            clientId: '1ddf87b0-f06f-4a2f-a4f0-f61ef7df6b23'
        }   
    }
};
